import { Component, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { OpportunityWorkflowSubmissionComponent } from '@features/opportunities/components/workflow/submission/opportunity-workflow-submission.component';
import { OpportunityEventService, OpportunityEvent } from '@features/opportunities/services/opportunity-event.service';
import { OpportunityWorkflowStatus } from '@shared/models/opportunity';
import { ModalSetting } from '@shared/components/modal/modal-setting';
import { Violation } from '@features/opportunities/modules/core/services/violation.contract';
import { productRecommendationDocumentViolationsCleared } from '@features/opportunities/models/document';
import { FeatureFlag } from '@env/environment.interface';

import { SidebarSubMenuItem } from './sub-menu.model';
import { MenuAttributes } from '@shared/enums/customisation.enum';
import { CustomisationService } from '@shared/services/customisation/customisation.service';
import { OpportunitySummary } from '@features/opportunities/models/opportunity';
import { FeatureFlagService } from '@core/services/feature-flag.service';

@Component({
  selector: 'spark-shared-sidebar-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss']
})
export class SparkSharedSidebarSubMenuComponent {  
  @Input() heading!: string;
  @Input() backRoute: string[] | null = null;
  @Input() routePrefix!: string[];
  @Input() items!: SidebarSubMenuItem[][];
  @Input() opportunityId!: string;
  @Input() violations: Violation[] = [];
  @Input() opportunitySummary: OpportunitySummary | null = null;

  private modal: BsModalRef | null = null;

  constructor(
    private readonly modalService: BsModalService,
    private readonly opportunityEventService: OpportunityEventService,
    private readonly customisationService: CustomisationService,
    private readonly featureFlagService: FeatureFlagService
  ) {}

  MenuAttributes = MenuAttributes;
  
  onSubmit() {
    this.openFormModal(
      OpportunityWorkflowSubmissionComponent,
      'SUBMITTED' as OpportunityEvent,
      this.opportunityId
    );
  }

  get showSubmitButton(): boolean {
    return (
      this.customisationService.getCustomisationForSideMenu().showSubmitButton &&
      this.featureFlagService.isEnabled(FeatureFlag.OpportunitySubmission)
    );
  }

  get canSubmit(): boolean {
    const SubmittableStatuses = [
      OpportunityWorkflowStatus.Draft,
      OpportunityWorkflowStatus.ReadyToSubmit,
      OpportunityWorkflowStatus.SubmissionFailed
    ];

    // Check status
    if (!SubmittableStatuses.includes(this.opportunitySummary?.summary.workflowDisplayState.status as OpportunityWorkflowStatus)) {
      return false;
    }

    // Check violations
    return productRecommendationDocumentViolationsCleared(this.violations);
  }

  private closeAndRefresh(completedEvent: OpportunityEvent): void {
    this.closeModal();
    this.opportunityEventService.fire(completedEvent);
  }

  private closeModal(): void {
    this.modal?.hide();
  }

  private openFormModal(
    component: any,
    completedEvent: OpportunityEvent,
    opportunityId: string,
    additionalContent: any = {}
  ): void {
    this.closeModal();
    let content: any = {
      cancel: () => this.closeModal(),
      saved: () => this.closeAndRefresh(completedEvent),
      opportunityId: opportunityId,
      ...additionalContent
    };

    this.modal = this.modalService.show(
      component,
      ModalSetting.createLargeModal(content)
    );
  }
}

